import easyToggle from 'easy-toggle-state';
easyToggle();
